module.exports = __webpack_public_path__ + "img/hzd.2305d6fb.png";